import React, { useState ,useEffect} from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import PubSub from 'pubsub-js';
import Select from "react-select";

import moment from "moment";
const SubjectEdit = (props) => {

  const [validated, setValidated] = useState(false);
  const [isVechile, setBranch] = useState(props ? props.vechileRec : {});
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState({});

  const [selectedTrasporter, setSelectedTrasporter] = useState({});
  const [TrasporterOption, setOptionTrasporter] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      
      const fnYear = await trasportApi.fetchAllActiveFinancialYears();
      const trasporter = await trasportApi.fetchAllTransporters();
  
      if (fnYear && fnYear.length) {
        let ar = [];
        //eslint-disable-next-line
        fnYear.map((item) => {
          var obj = {};
          obj.value = item.id;
          obj.label = item.name;
          ar.push(obj);
        });
        if (props?.vechileRec) {
          let acc = ar.filter((acc) => acc.value === props.vechileRec.financial_year_id);
          setSelectedFinancialYear(acc);
        }

        
        // // Check if the current year matches any option
        // const currentYear = new Date().getFullYear();
        // const defaultOption = ar.find(option => option.label === currentYear.toString());

        // if (defaultOption) {
        // setSelectedFinancialYear([defaultOption]); // Set the default selected option
        // }
        setOptionFinancialYear(ar);
      } else {
        setOptionFinancialYear([]);
      }

      if (trasporter && trasporter.length) {
        let ar = [];
        //eslint-disable-next-line
        trasporter.map((item) => {
          var obj = {};
          obj.value = item.id;
          obj.label = item.transporter_name;
          ar.push(obj);
        });
        if (props?.vechileRec) {
          let acc = ar.filter((acc) => acc.value === props.vechileRec.transporter_id);
          setSelectedTrasporter(acc);
        }

        
        // // Check if the current year matches any option
        // const currentYear = new Date().getFullYear();
        // const defaultOption = ar.find(option => option.label === currentYear.toString());

        // if (defaultOption) {
        // setSelectedFinancialYear([defaultOption]); // Set the default selected option
        // }
        setOptionTrasporter(ar);
      } else {
        setOptionTrasporter([]);
      }
    };
  
    fetchData();
  }, []);
 
  const checkRequiredFields = () => {
    if (
      isVechile.vehicle_number &&
      isVechile.vehicle_number.trim() !== "" &&
      isVechile.transporter_id &&
      isVechile.transporter_id.trim() !== "" &&
      isVechile.rc_owner &&
      isVechile.rc_owner.trim() !== "" &&
      isVechile.financial_year_id &&
      isVechile.financial_year_id.trim() !== ""
    ) {
     
      return false;
    }
    return true;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
   

    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    let result2 = {};

    if (isVechile.id) {
      result2 = await trasportApi.saveVehicles(isVechile);
      if (result2.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Updated successfully' });
      }
    } else {
      result2 = await trasportApi.createVehicles(isVechile);
      if (result2.errors) {
        console.log("s",result2.error);
        setError(result2.errors);
      }
      if (result2?.id) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record saved successfully' });
      } else {
        //submitDoctorDuties();
        //PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }

  };

  const handlefinancialYear = (e) => {
    setSelectedFinancialYear(e);
    setBranch({ ...isVechile, financial_year_id: e.value });
  };

  const handleTrasporter = (e) => {
    setSelectedTrasporter(e);
    setBranch({ ...isVechile, transporter_id: e.value });
  };

  // const handleVechile  = async (e) => {
  //   setBranch({ ...isVechile, [e.target.name]: e.target.value });
  // };

  const handleVechile = async (e) => {
    const { name, value } = e.target;
  
    // Update state first
    setBranch({ ...isVechile, [name]: value });
  
    // Check if vehicle number exists in the database
    // if (name === "vehicle_number" && value.trim() !== "") {
    //   try {
    //     const response = await trasportApi.fetchByVechileNumber(value, isVechile.financial_year_id)
  
    //     if (response) {
    //       setError((prev) => ({ ...prev, vehicle_number: "Already Exist" }));
    //     } else {
    //       setError((prev) => ({ ...prev, vehicle_number: "" })); // Clear error if not found
    //     }
    //   } catch (error) {
    //     console.error("Error checking vehicle:", error);
    //   }
    // }
  };
  

  return (
    <Modal {...props} size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Vechile
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form
                className="mt-3"
                onSubmit={handleSubmit}
                controlId="subjectCreate"
                noValidate validated={validated}
              >
                <Row>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Financial Year
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Financial Year"
                      value={selectedFinancialYear}
                      onChange={handlefinancialYear}
                      options={financialYearOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Financial Year.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Trasporter 
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Financial Year"
                      value={selectedTrasporter}
                      onChange={handleTrasporter}
                      options={TrasporterOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Trasporter Year.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                      Vehicle Number
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="vehicle_number"
                        placeholder="Enter Vehicle Number"
                        value={isVechile.vehicle_number}
                        onChange={handleVechile }
                        style={{ height: "38px" }}
                        // className={`form-control ${error ? "is-invalid" : ""}`}
                      />
                      <span className="mt-2" style={{color : "red"}}>{error ? error : "" }</span>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                      Rc Owner
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="rc_owner"
                        placeholder="Enter Rc Owner"
                        value={isVechile.rc_owner}
                        onChange={handleVechile}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                      Pan Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="pan_number"
                        placeholder="Enter Pan Number"
                        value={isVechile.pan_number}
                        onChange={handleVechile}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                         Engine Number
                      </Form.Label>
                      <Form.Control
                        required
                        type="number"
                        name="engine_number"
                        placeholder="Enter Engine Number"
                        value={isVechile.engine_number}
                        onChange={handleVechile }
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                      Chasis Number
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="chasis_number"
                        placeholder="Enter Chasis Number"
                        value={isVechile.chasis_number}
                        onChange={handleVechile}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                      Remark
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="remark"
                        placeholder="Enter remark"
                        value={isVechile.remark}
                        onChange={handleVechile}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} variant="light">
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal >
  );
};
export default SubjectEdit;
